import { Component, GameEvent, Query, SystemType, World } from "excalibur";
import { notEmpty } from "../common";
import { StrictEventEmitter } from "../engine/types";

export class TurnBasedComponent extends Component {
  constructor(
    public onTurnStart: () => void | Promise<void>,
    public onTurnComplete: () => void,
  ) {
    super();
  }
}

type TurnEvents = {
  movestart: TurnMoveStartEvent;
  movecomplete: TurnMoveCompleteEvent;
};

export class TurnMoveCompleteEvent extends GameEvent<TurnBasedSystem> {
  constructor(public target: TurnBasedSystem) {
    super();
  }
}

export class TurnMoveStartEvent extends GameEvent<void> {
  constructor(private promises: Promise<void>[]) {
    super();
  }

  withTurn(fn: () => void | Promise<void>) {
    const executeAsync = async () => {
      await fn();
    };
    this.promises.push(executeAsync());
  }
}

export const TurnEvents = {
  Movecomplete: "movecomplete",
  Movestart: "movestart",
} as const;

export class TurnBasedSystem {
  query: Query<typeof TurnBasedComponent>;
  public events = new StrictEventEmitter<TurnEvents>();
  private _updating = false;

  get updating(): boolean {
    return this._updating;
  }

  constructor(world: World) {
    this.query = world.query([TurnBasedComponent]);
  }

  public systemType = SystemType.Update;

  triggerTurn(): void {
    console.log("TURN STARTING");
    this._updating = true;
    //this.events.emit(TurnEvents.Movestart, new TurnMoveStartEvent(promises));

    const promises = this.query.entities
      .map((e) => e.get(TurnBasedComponent).onTurnStart())
      .filter(notEmpty);

    // Wait for all mob movements to complete
    void Promise.allSettled(promises).then(() => this.turnComplete());
  }

  turnComplete() {
    this._updating = false;
    console.log("TURN COMPLETING");
    this.events.emit(TurnEvents.Movecomplete, new TurnMoveCompleteEvent(this));
    this.query.entities.forEach((e) =>
      e.get(TurnBasedComponent).onTurnComplete(),
    );

    console.log("TURN COMPLETE");
  }
}
